$(function() {
    return $(document).on('change', '#payroll_concept', function() {
        concept = $(this)
        $.getJSON("/concepts/search_concept/" + concept.val() + ".json", function(result) {
            if (result) {
                resetInputsPayroll()
                $('.concept-items').addClass('hidden')
                if (result.concept_amount == false) {
                    $('#payroll_salary').prop('readonly', true)
                }
                if (result.concept_days == true) {
                    $('#payroll_days').parent('.form-custom').removeClass('hidden')
                    $('#payroll_days').prop('required', true)
                }
                if (result.concept_amount_ns == true) {
                    $('#payroll_no_salary').prop('readonly', false)
                }
                if (result.concept_hours == true) {
                    $('#payroll_hours').parent('.form-custom').removeClass('hidden')
                    $('#payroll_hours').prop('required', true)
                }
                if (result.concept_init_date == true) {
                    $('#payroll_init_date').parent('.form-custom').removeClass('hidden')
                    $('#payroll_init_date').prop('required', true)
                }
                if (result.concept_end_date == true) {
                    $('#payroll_end_date').parent('.form-custom').removeClass('hidden')
                    $('#payroll_end_date').prop('required', true)
                }
                if (result.concept_percentage == true) {
                    $('#payroll_percentage').parent('.form-custom').removeClass('hidden')
                    $('#payroll_percentage').prop('required', true)
                }
                if (result.concept_ordinary_compensation == true) {
                    $('#payroll_ord_comp').parent('.form-custom').removeClass('hidden')
                    $('#payroll_ord_comp').prop('required', true)
                }
                if (result.concept_extraordinary_compensation == true) {
                    $('#payroll_extra_comp').parent('.form-custom').removeClass('hidden')
                    $('#payroll_extra_comp').prop('required', true)
                }
                if (result.concept_cesantias_interest == true) {
                    $('#payroll_cesantias_interest').parent('.form-custom').removeClass('hidden')
                    $('#payroll_cesantias_interest').prop('required', true)
                }
                if (result.concept_cesantias_interest == true) {
                    $('#payroll_cesantias_interest').parent('.form-custom').removeClass('hidden')
                    $('#payroll_cesantias_interest').prop('required', true)
                }
                if (result.concept_medical_leave_type == true) {
                    $('#payroll_medical_leave_type').parent('.form-custom').removeClass('hidden')
                    $('#payroll_medical_leave_type').prop('required', true)
                }
                if (result.concept_code == 'OTRO_CONCEPTO') {
                    $('#payroll_description').parent('.form-custom').removeClass('hidden')
                    $('#payroll_description').prop('required', true)
                } else {
                    $('#payroll_description').parent('.form-custom').addClass('hidden')
                    $('#payroll_description').prop('required', false)
                }
            }
        })
    })
})

function resetInputsPayroll() {
    $('#payroll_medical_leave_type').val('')
    $('#payroll_init_date').val('')
    $('#payroll_end_date').val('')
    $('#payroll_percentage').val('')
    $('#payroll_extra_comp').val('')
    $('#payroll_cesantias_interest').val('')
    $('#payroll_days').val('')
    $('#payroll_hours').val('')
    $('#payroll_ord_comp').val('')
    $('#payroll_salary').val('')
    $('#payroll_salary').prop('readonly', false)
    $('#payroll_no_salary').val('')
    $('#payroll_no_salary').prop('readonly', true)
    $("#accrud-total").text('$0')
    $("#payroll_description").val('')
}

$(function() {
    return $(document).on('change', '#deduction_concept', function() {
        concept = $(this)
        $.getJSON("/concepts/search_concept/" + concept.val() + ".json", function(result) {
            if (result) {
                resetInputsDeductionPayroll()
                $('.deduction-items').addClass('hidden')
                if (result.concept_amount == false) {
                    $('#deduction_value').prop('readonly', true)
                }
                if (result.concept_description == true) {
                    $('#deduction_description').parent('.form-custom').removeClass('hidden')
                    $('#deduction_description').prop('required', true)
                }
                if (result.concept_private_sanction == true) {
                    $('#deduction_private_sanction').parent('.form-custom').removeClass('hidden')
                    $('#deduction_private_sanction').prop('required', true)
                }
                if (result.concept_public_sanction == true) {
                    $('#deduction_public_sanction').parent('.form-custom').removeClass('hidden')
                    $('#deduction_public_sanction').prop('required', true)
                }
                if (result.concept_percentage == true) {
                    $('#deduction_percentage').parent('.form-custom').removeClass('hidden')
                    $('#deduction_percentage').prop('required', true)
                }
            }
        })
    })
})

function resetInputsDeductionPayroll() {
    $('#deduction_description').val('')
    $('#deduction_private_sanction').val('')
    $('#deduction_public_sanction').val('')
    $('#deduction_percentage').val('')
    $('#deduction_percentage').prop('required', false)
    $('#deduction_value').val('')
    $('#deduction_value').prop('readonly', false)
    $("#deduction-total").text('$0')
}

$(function() {
    return $(document).on('change keyup', '.calculate-accrud-total', function() {
        sum = 0
        $('.calculate-accrud-total').each(function() {
            if ($(this).val().length > 0) {
                sum += parseFloat($(this).val())
            }
        });
        $("#accrud-total").text('$' + Intl.NumberFormat().format(sum))
    })
})

$(function() {
    return $(document).on('change keyup', '.calculate-deduction-total', function() {
        sum = 0
        $('.calculate-deduction-total').each(function() {
            if ($(this).val().length > 0) {
                sum += parseFloat($(this).val())
            }
        });
        $("#deduction-total").text('$' + Intl.NumberFormat().format(sum))
    })
})